import { render, staticRenderFns } from "./CandidateAnswersItem.vue?vue&type=template&id=9d921a44&"
import script from "./CandidateAnswersItem.vue?vue&type=script&lang=js&"
export * from "./CandidateAnswersItem.vue?vue&type=script&lang=js&"
import style0 from "./CandidateAnswersItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports